import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Outlet, useLocation } from 'react-router-dom';
import { Grid, useTheme } from '@mui/material';
import backgroundImage from '../landing/background.svg';
import { PopAppBar } from '../appBar/PopAppBar';
import Disclaimer from 'components/common/Disclaimer';
import { Footer } from 'components/landing/Collaborators';

const useCopy = () => {
  const intl = useIntl();
  const messages = defineMessages({
    paragraph1: {
      id: 'home.disclaimer.paragraph1',
      defaultMessage:
        'The product may contain links to external websites or resources for further information. We do not endorse or take responsibility for the accuracy, reliability, or content of any third-party websites or resources. The content on the external links may be subject to change without prior notice. The owners of the external links reserve the right to modify, update, or remove any content at their discretion.',
    },
  });

  const paragraph1 = intl.formatMessage(messages.paragraph1);

  return { paragraph1 };
};

export const Home = () => {
  const copy = useCopy();
  const theme = useTheme();
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  const styleProps = {
    textAlign: 'justify',
  };

  return (
    <Grid
      container
      direction={'column'}
      wrap={'nowrap'}
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        bgcolor: 'background.default',
        height: '100%',
        // TODO This is a hack until we get the tablet size.  We just force it to desktop
        [theme.breakpoints.up('sm')]: {
          minWidth: '1280px',
        },
      }}
    >
      <Grid
        item
        xs={2}
        px="3.75rem"
        pt="3.75rem"
        sx={{
          [theme.breakpoints.down('sm')]: {
            px: '0.8rem',
            pt: '2rem',
          },
        }}
      >
        <PopAppBar />
      </Grid>
      <Grid item xs={10}>
        <Outlet />
        {isHomePage && <Disclaimer paragraph1={copy.paragraph1} styleProps={styleProps} />}
        <Footer />
      </Grid>
    </Grid>
  );
};
